import { useEffect, useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { getCmdbObjectSchemaByIdUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object-schema.tsx';
import type { ObjectSchema } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/object-schema.tsx';

type LoadingState = 'idle' | 'loading' | 'success' | 'error';

export const useSchemaDetails = (workspaceId?: string, schemaId?: string) => {
	const [data, setData] = useState<ObjectSchema | undefined>();
	const [loadingState, setLoadingState] = useState<LoadingState>('idle');
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (!workspaceId || !schemaId || loadingState !== 'idle') return;
		setLoadingState('loading');
		performGetRequest(getCmdbObjectSchemaByIdUrl(workspaceId, schemaId))
			.then((schema) => {
				setData(schema);
				fireTrackAnalytics(createAnalyticsEvent({}), 'fetchCmdbFieldSchemaDetails succeeded');
				setLoadingState('success');
			})
			.catch((error) => {
				fireCmdbErrorAnalytics({
					error,
					meta: {
						id: 'fetchCmdbFieldSchemaDetails',
						packageName: 'jiraIssueFieldCmdbObject',
					},
				});
				setLoadingState('error');
			});
	}, [createAnalyticsEvent, loadingState, schemaId, workspaceId]);

	return { data, loadingState };
};
